<template>
  <header :id="$attrs['id']" class="header header--white">
    <div class="header__content">
      <div class="header__name">
        <div class="btn__back" @click="onClickBack">
          <icon icon="back" />
        </div>
        <div class="header__name__content">
          <portal-target ref="portal" name="headerTitle" slim @change="changeTitle">
            {{ hotelName }}
          </portal-target>
        </div>
        <div :class="[{'header__save-in-progress--active': saveInProgress}]" class="header__save-in-progress">
          <span>{{ $t('layout.appHeader.saving') }}</span>
          <svg width="11px"
               height="14px"
               viewBox="0 0 11 14"
               version="1.1"
               xmlns="http://www.w3.org/2000/svg"
               xmlns:xlink="http://www.w3.org/1999/xlink">
            <g stroke="none"
               stroke-width="1"
               fill="none"
               fill-rule="evenodd"
               stroke-linecap="round">
              <g transform="translate(-11.000000, -9.000000)" stroke="#FFFFFF">
                <g class="loading-burger" transform="translate(11.000000, 9.000000)">
                  <path d="M0.5,1 L10.5,1" class="loading-burger__line loading-burger__line--1"></path>
                  <path d="M0.5,5 L10.5,5" class="loading-burger__line loading-burger__line--2"></path>
                  <path d="M0.5,9 L10.5,9" class="loading-burger__line loading-burger__line--3"></path>
                  <path d="M0.5,13 L10.5,13" class="loading-burger__line loading-burger__line--4"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="header__right">
        <hm-notifications v-if="hasRole('ROLE_USER')"/>
        <div :class="{'header__hamburger--active': navVisible}" class="header__hamburger" @click="openMenu">
          <svg viewBox="0 0 28 18">
            <g stroke="none"
               stroke-width="1"
               fill="none"
               fill-rule="evenodd"
               stroke-linecap="square">
              <g transform="translate(-333 -21)" stroke="#FFF">
                <g class="svg-burger" transform="translate(334 21)">
                  <path pid="0" d="M.394 9h25.212" class="svg-burger__bun svg-burger__bun--1"></path>
                  <path pid="1" d="M.394 9h25.212" class="svg-burger__meat"></path>
                  <path pid="2" d="M.394 9h25.212" class="svg-burger__bun svg-burger__bun--2"></path>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import { isNil, isEmpty, throttle } from 'lodash';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';
import HotelSettingsMixin from '../../../mixins/HotelSettingsMixin';
import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';

export default {
  name: 'AppHeader',
  components: { },

  mixins: [HotelSettingsMixin, UpdateHotelSettingsMixin, HotelmeisterMixin],
  props: [],

  head: {
    title: function () {
      return {
        inner: isEmpty(this.titleContent) ? this.hotelName : `${this.hotelName} / ${this.titleContent}`,
      };
    },
  },

  data() {
    return {
      titleContent: null,
      onClickBack: throttle(this._onClickBack, 1000, { leading: true, trailing: false }),
    };
  },
  computed: {
    hotelName: function () {
      if (isNil(this.hotelSettings) || isNil(this.hotelSettings.hotel)) return '';

      return this.hotelSettings.hotel.hotelName;
    },
    navVisible: function () {
      return this.$store.getters['layout/navVisible'];
    },
    saveInProgress: function () {
      return this.$store.getters['save/saveInProgress'];
    },
  },
  methods: {
    _onClickBack(event) {
      if (!isEmpty(this.$route.meta.parent)) {
        this.$router.push({
          name: this.$route.meta.parent,
          params: {
            ...this.$route.params,
            expandedSubmenu: this.$route.meta.expandedSubmenu,
          },
        });
      }
      this.$root.$emit('clickHeaderBack');
    },
    openMenu(event) {
      this.$store.dispatch('layout/navVisible', !this.$store.getters['layout/navVisible']);
    },
    changeTitle(newContent, oldContent) {
      this.titleContent = isEmpty(this.$refs.portal.passengers) ? null : this.$refs.portal.passengers[0].text;
      this.$emit('updateHead');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
   @import '~styles/components/lib/AppHeader';

  .icon__loading {
    display: inline-block;
    height: 3rem;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/AppHeaderWhite.vue